import axios from "@axios";

export default {
  loadOndontogramas() {
    return axios.get(`/atendimento/odontograma/`);
  },
  generate(data) {
    return axios.post("/atendimento/odontograma/gerar/", data);
  },
  editTooth(data) {
    return axios.put(`/atendimento/odontograma/dente/${data.id}`, data);
  },
  getById(id) {
    return axios.get(`/atendimento/odontograma/${id}`);
  },
  getPatientById(id) {
    return axios.get(`/atendimento/odontograma/paciente/${id}`);
  },
  getStatus() {
    return axios.get("/atendimento/odontograma_status/lista");
  },
};
